import ReactGA from 'react-ga4';

export function init() {
  if (enabledReactGA()) {
    ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID);
  }
}

export function setPageview(page) {
  if (enabledReactGA()) {
    ReactGA.send({ hitType: 'pageview', page: page });
  } else {
    console.log(`PageView: ${page}`);
  }
}

export function setEvent(event) {
  if (enabledReactGA()) {
    ReactGA.event(event);
  } else {
    if (event && typeof event === 'object') {
      const { category, action, label, value } = event;
      console.log(
        `Event - category: ${category}, action: ${action}, label: ${label}, value: ${value}`
      );
    }
  }
}

export function enabledReactGA() {
  return process.env.REACT_APP_GA_TRACKING_ID && process.env.REACT_APP_DEPLOY_ENV === 'production';
}
